/* eslint-disable no-nested-ternary */

'use client';

import { Box, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

import Link from '@/components/Link';
import NearFullStar from '@/components/SvgIcons/NearFullStar';
import Clutch from '@/components/SvgIcons/Socials/Clutch';
import Star from '@/components/SvgIcons/Star';
import { clutchPlatform } from '@/config/review-platforms.config';
import colors from '@/styles/themes/colors';

import styles from './ClutchWidget.module.scss';

interface ClutchWidgetProps {
  className?: string;
  variant?: 'hero' | 'footer' | 'compact';
}

const ClutchWidget = ({ className, variant = 'hero' }: ClutchWidgetProps) => {
  const tHome = useTranslations('home.heroSection');

  const isHero = variant === 'hero';
  const isFooter = variant === 'footer';
  const isCompact = variant === 'compact';

  const clutchSize = isHero ? 20 : 28;
  const clutchFill = isFooter ? colors.white : isCompact ? colors.black : undefined;
  const textColor = isFooter ? colors.white : isCompact ? colors.graytone950 : colors.graytone200;
  const stackDirection = isHero ? 'row' : 'column';

  return (
    <Stack gap={2} alignItems="flex-start" className={className}>
      {isHero && (
        <>
          <Typography variant="body1" maxWidth={{ xs: '100%', md: '240px' }}>
            {tHome('reviewsText')}
          </Typography>
          <Box className={styles.divider} />
        </>
      )}
      <Stack direction={stackDirection} alignItems={isHero ? 'center' : 'flex-start'} gap={1}>
        <Stack direction="row">
          <Clutch size={clutchSize} fill={clutchFill} />
          <Stack direction="row" alignItems="center" gap={0.5}>
            {Array.from({ length: 4 }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Star key={index} size={16} fill={colors.orange500} />
            ))}
            <NearFullStar size={16} fill={colors.orange500} />
          </Stack>
        </Stack>
        <Typography variant="body2" component="p" color={textColor}>
          {clutchPlatform.reviewCount} {tHome('reviews')}
        </Typography>
      </Stack>
      {isHero && <Link href="/reviews" text={tHome('link')} className={styles.link} />}
    </Stack>
  );
};

export default ClutchWidget;
